
//renders the wishlist item number 
document.addEventListener("DOMContentLoaded", function() { 
  function swymCallbackFn(){
    var wishlistItemsContainer = document.getElementById("wishlist-items");
    if(wishlistItemsContainer){
      window._swat.fetchWrtEventTypeET(
        function(wishlistProducts) {
          var numOfWishlistItems = wishlistProducts.length;
          var wishlistItems = document.querySelector(".wishlistItems");
          wishlistItems.append((numOfWishlistItems));
        },
        window._swat.EventTypes.addToWishList
      );
    } 
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  
});